import React, { useEffect } from "react"
import { Breadcrumb2 } from "./Breadcrumb2"
import { removerBreadcrumbOriginal } from "./breadcrumb2Utils"

export type Breadcrumb2ContainerProps = {
    passos:string[]
    exibirBotaoLimpar:boolean
    exibirBotaoVoltar: boolean
    exibirBotaoEditar?: boolean
    processando?: boolean
    id?: string
    onBotaoLimparClicado?: () => void
    onBotaoVoltarClicado?: ()=> void
    onBotaoEditaClicado?: ()=> void
    onPassoSelecionado?: (passo:string) => void
}

export const Breadcrumb2Container = (props: Breadcrumb2ContainerProps) => {
    useEffect(() => {
        removerBreadcrumbOriginal()
    },[])

    return <>
        <Breadcrumb2
            passos={props.passos}
            exibirBotaoLimpar={props.exibirBotaoLimpar}
            exibirBotaoVoltar={props.exibirBotaoVoltar}
            exibirBotaoEditar={props.exibirBotaoEditar}
            processando={props.processando}
            id={props.id}
            key={props.id?.length > 0 ? `${props.id}Breadcrumb2` : undefined}
            onBotaoLimparClicado={props.onBotaoLimparClicado}
            onBotaoVoltarClicado={props.onBotaoVoltarClicado}
            onBotaoEditarClicado={props.onBotaoEditaClicado }
            onPassoSelecionado={props.onPassoSelecionado}/>
    </>
}